import { render, staticRenderFns } from "./CasualLanguage.vue?vue&type=template&id=31af55a6&"
import script from "./CasualLanguage.vue?vue&type=script&lang=js&"
export * from "./CasualLanguage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports